import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { http, formatApiError } from "../lib/api";
import { CheckCircle2 } from "lucide-react";
import { BrandBlock } from "../components/BrandBlock";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const nav = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pwd.length < 6) return setErr("Mot de passe trop court (6 min)");
    if (pwd !== pwd2) return setErr("Les mots de passe ne correspondent pas");
    setLoading(true);
    try {
      await http.post("/auth/reset-password", { token, new_password: pwd });
      setDone(true);
      setTimeout(()=> nav("/login"), 1800);
    } catch (e2) { setErr(formatApiError(e2)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-white p-6">
      <div className="w-full max-w-sm">
        <div className="mb-10">
          <BrandBlock size="md" />
        </div>

        {!token ? (
          <div className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-md px-3 py-3">Lien invalide. <Link to="/forgot-password" className="underline">Recommencer</Link></div>
        ) : done ? (
          <div className="rounded-md border border-emerald-200 bg-emerald-50 text-emerald-800 p-4 flex items-center gap-3"><CheckCircle2 className="h-6 w-6"/><div><b>Mot de passe mis à jour !</b><br/>Redirection vers la connexion…</div></div>
        ) : (
          <>
            <h1 className="font-display text-4xl font-extrabold tracking-tight mb-2">Nouveau mot de passe</h1>
            <p className="text-sm text-slate-600 mb-8">Choisissez un nouveau mot de passe (au moins 10 caractères, avec des lettres et des chiffres).</p>
            <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
              <div>
                <label className="text-[10px] font-bold uppercase tracking-widest text-slate-500">Nouveau mot de passe</label>
                <input data-testid="reset-pwd" type="password" required value={pwd} onChange={(e)=>setPwd(e.target.value)}
                  className="mt-1 w-full border border-slate-300 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-sky-500"/>
              </div>
              <div>
                <label className="text-[10px] font-bold uppercase tracking-widest text-slate-500">Confirmer</label>
                <input data-testid="reset-pwd2" type="password" required value={pwd2} onChange={(e)=>setPwd2(e.target.value)}
                  className="mt-1 w-full border border-slate-300 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-sky-500"/>
              </div>
              {err && <div className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-md px-3 py-2">{err}</div>}
              <button data-testid="reset-submit" disabled={loading} className="w-full disabled:opacity-70 text-white font-semibold rounded-md py-2.5 text-sm hover:opacity-90" style={{ backgroundColor: "var(--brand-primary)" }}>{loading?"…":"Réinitialiser"}</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
